function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2494 28.6538H4.01001L22.7602 18.8652H63.9996L45.2494 28.6538Z",
  fill: "#F7CFC2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9997 18.8646L45.1893 0.0231847L3.92676 0L22.7603 18.8646H63.9997Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2494 28.6538H4.01001L22.7602 18.8652H63.9996L45.2494 28.6538Z",
  fill: "#CCCCCC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.1895 0.0231847L41.5462 3.67246C40.4552 4.76523 38.9754 5.37885 37.4323 5.37885L1.01048 5.36031C0.112394 5.36031 -0.338192 4.27217 0.297566 3.63536L3.92694 0L45.1895 0.0231847Z",
  fill: "#F7CFC2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M45.1895 0.0231847L41.5462 3.67246C40.4552 4.76523 38.9754 5.37885 37.4323 5.37885L1.01048 5.36031C0.112394 5.36031 -0.338192 4.27217 0.297566 3.63536L3.92694 0L45.1895 0.0231847Z",
  fill: "#CCCCCC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7602 18.8652V28.6538H4.01001L22.7602 18.8652Z",
  fill: "#999999"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2494 28.6538V44.0284L41.5491 47.9992H44.2557C44.9099 47.9992 45.5534 47.8415 46.1321 47.5385L63.3624 38.5429C63.7543 38.3389 63.9997 37.9323 63.9997 37.4903V18.8652L45.2494 28.6538Z",
  fill: "#999999"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9904 24.2676L57.4569 27.8195C54.9741 29.1843 53.4294 31.7964 53.4294 34.6342C53.4294 37.0331 55.9925 38.5571 58.0942 37.4087L63.9997 34.1845L63.9904 24.2676V24.2676Z",
  fill: "#0055FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.01001 28.627H45.2494V46.7543C45.2494 47.4421 44.6923 48.0001 44.0057 48.0001H5.19511C4.54084 48.0001 4.01001 47.4684 4.01001 46.813V28.627V28.627Z",
  fill: "#F2F2F2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M45.2494 46.7539C45.2494 46.7539 45.467 47.8853 46.7262 47.2284C46.7262 47.2284 45.5164 48.0399 44.2542 47.9997C44.2542 47.9997 45.2494 47.6859 45.2494 46.7539Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2324 38.3301C23.9021 38.3301 23.6691 38.565 23.666 38.9097C23.663 39.2544 23.8975 39.5048 24.2277 39.5048C24.5595 39.5079 24.7925 39.2667 24.7956 38.9205C24.7987 38.5743 24.5641 38.3316 24.2339 38.3316L24.2324 38.3301Z",
  fill: "#00BAFF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3524 38.9108C29.3508 38.5677 29.1194 38.3297 28.7907 38.3281C28.462 38.3281 28.229 38.5646 28.2259 38.9077C28.2213 39.2524 28.4558 39.4997 28.7876 39.5028C29.1178 39.5059 29.3508 39.2663 29.3554 38.9232H29.3539V38.9093L29.3524 38.9108Z",
  fill: "#00BAFF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5117 38.3277C26.1799 38.3277 25.9485 38.5642 25.9454 38.9073C25.9408 39.252 26.1753 39.4993 26.5071 39.5024C26.8373 39.5055 27.0703 39.2659 27.0749 38.9228V38.9089C27.0734 38.5657 26.845 38.3262 26.5132 38.3262L26.5117 38.3277Z",
  fill: "#00BAFF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7629 33.4469H4.01001V43.9928H28.7629C31.6701 43.9928 34.0264 41.6326 34.0264 38.7191C34.0264 35.8071 31.6701 33.4453 28.7629 33.4453V33.4469Z",
  fill: "#0055FF"
});

function SvgPackM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 49,
    viewBox: "0 0 64 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref9), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = React.forwardRef(SvgPackM);
export default __webpack_public_path__ + "static/media/pack-m.d911ad98.svg";
export { ForwardRef as ReactComponent };